import { Link } from 'react-router-dom';
import LegalPage, { Section } from './LegalPage';

export default function TermsPage() {
  return (
    <LegalPage
      title="Terms & Betting Rules"
      intro="These terms govern your use of My Bets, operated by Marome Investments (Pty) Ltd. By registering and placing bets you agree to these terms. Betting is for entertainment only and is restricted to adults 18 and older."
    >
      <Section heading="1. Eligibility">
        <p>
          You must be 18 or older and a resident of South Africa to open an account. We verify
          your identity and age at registration (FICA/KYC). One account per person — duplicate or
          fraudulent accounts may be closed and balances forfeited.
        </p>
      </Section>

      <Section heading="2. Your account">
        <p>
          Keep your login details secure and do not share your account. You are responsible for all
          activity on your account. We may request further verification before processing
          withdrawals.
        </p>
      </Section>

      <Section heading="3. How bets are placed">
        <p>
          A bet is placed when you confirm a selection and stake from your bet slip and we accept it.
          The odds shown at the moment we accept the bet are the odds that apply. We may decline or
          limit any bet at our discretion, for example where odds were displayed in error or a market
          is suspended.
        </p>
      </Section>

      <Section heading="4. How bets are settled">
        <p>
          Winning bets are settled and paid into your wallet once the official result of the relevant
          event is confirmed. Payouts are calculated as your stake multiplied by the accepted decimal
          odds. We settle on the official result; subsequent disqualifications or changes after
          settlement do not alter already-settled bets unless required by law.
        </p>
      </Section>

      <Section heading="5. Voided bets">
        <p>
          A bet may be voided (your stake returned) where an event is abandoned, postponed beyond a
          reasonable period, or where a clear error occurred (for example a palpable odds error or a
          selection that should not have been offered). Voided legs in a multi/accumulator are treated
          as odds of 1.00 and the remaining legs stand.
        </p>
      </Section>

      <Section heading="6. Cash out">
        <p>
          Where cash out is offered, you may settle a qualifying bet early for an amount we calculate
          from the live odds. Cash out is offered at our discretion and may be unavailable when a
          market is suspended.
        </p>
      </Section>

      <Section heading="7. Deposits and withdrawals">
        <p>
          Deposits and withdrawals are processed by our licensed payment provider. Withdrawals are paid
          to a verified account in the registered customer&apos;s own name. The{' '}
          <strong className="text-text-primary">same-name payout rule</strong> applies: we only pay
          winnings to a bank account or payment method that matches the verified name on your account.
          Withdrawals may be subject to identity verification and applicable limits.
        </p>
      </Section>

      <Section heading="8. Responsible gambling">
        <p>
          We provide tools to help you stay in control — deposit limits, time-outs and self-exclusion.
          See our{' '}
          <Link to="/responsible-gambling" className="font-semibold text-primary hover:underline">
            Responsible Gambling
          </Link>{' '}
          page. Gambling can be addictive; never bet more than you can afford to lose.
        </p>
      </Section>

      <Section heading="9. AI insights">
        <p>
          Any AI-generated insights, probabilities or predictions are for information and entertainment
          only. They are estimates based on available data and do not guarantee any outcome. Bets are
          placed entirely at your own discretion and risk.
        </p>
      </Section>

      <Section heading="10. Changes and contact">
        <p>
          We may update these terms from time to time; material changes will be notified. To raise a
          dispute, see our{' '}
          <Link to="/complaints" className="font-semibold text-primary hover:underline">
            Complaints
          </Link>{' '}
          page. For how we handle your data, see our{' '}
          <Link to="/privacy" className="font-semibold text-primary hover:underline">
            Privacy notice
          </Link>
          .
        </p>
      </Section>
    </LegalPage>
  );
}
